import { render, staticRenderFns } from "./UserFullnameText.vue?vue&type=template&id=03d7bef1&scoped=true"
import script from "./UserFullnameText.vue?vue&type=script&lang=js"
export * from "./UserFullnameText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d7bef1",
  null
  
)

export default component.exports